import * as React from 'react';
import { observer } from 'mobx-react';
import { injectTSDI } from '../../core/tsdi';
import { LoaderFullPage } from '../../components/loader';
import { useScopedGoogleAnalytics } from '../../core/analytics/google-analytics';
import { useScopedFacebookPixel } from '../../core/analytics/facebook-pixel';
import { StudioStore } from '../../core/studio-store';
import { errorCode } from '../../components/error-handler';
import { FeatureStore } from '../../core/feature-store';

export interface StudioProviderProps {
    studioId: number;
    children: React.ReactNode;
    studioGoogleAnalyticsId?: string;
    studioFacebookPixelId?: string;
    studioActiveForConfiguration: boolean;
}

export const StudioProvider = observer((props: StudioProviderProps) => {
    const {
        children,
        studioId,
        studioFacebookPixelId,
        studioGoogleAnalyticsId,
        studioActiveForConfiguration
    } = props;
    const studioStore = injectTSDI(StudioStore);
    const featureStore = injectTSDI(FeatureStore);

    React.useEffect(() => {
        if (studioId) {
            void studioStore.setStudioId(studioId);
            void featureStore.init(studioId);
        }
        return () => {
            studioStore.resetStudioId();
            featureStore.reset();
        };
    }, [featureStore, studioId, studioStore]);

    useScopedGoogleAnalytics(studioGoogleAnalyticsId);
    useScopedFacebookPixel(studioFacebookPixelId);

    if (!studioActiveForConfiguration) {
        throw errorCode('SHNC');
    }

    return studioStore.studioRequest.match({
        loading: () => <LoaderFullPage />,
        fetched: () => <>{children}</>
    });
});
